exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.signatureWrapper[data-v-2bd77878] {\n    width: 100%;\n    border: 1px solid lightgray;\n}\n.link-danger[data-v-2bd77878] {\n    color: red;\n}\n", ""]);

// exports
